import {H5WeatherObservationData, H5WeatherVariableGroup} from 'src/lib/api/h5';
import {
  ApiObservationTimeSeries,
  TimeSeriesData,
  TimeSeriesVariables,
  WeatherColumns,
} from 'src/lib/api/series';
import {chartSourceFor} from 'src/lib/h5/toWeatherForecastTimeSeries';

const WEATHER_COLUMN_BY_GROUP: Record<H5WeatherVariableGroup, WeatherColumns> = {
  temperature: WeatherColumns.TEMPERATURE,
  precipitation: WeatherColumns.PRECIPITATION,
};

/**
 * An H5 observation response as the v2 observation time series the chart draws a source's
 * observed weather from. Undefined when the source has no chart identity or the window holds none.
 */
export function toWeatherObservationTimeSeries(
  observationData: H5WeatherObservationData,
  {siteId}: {siteId: string}
): ApiObservationTimeSeries | undefined {
  const source = chartSourceFor(observationData.source);
  const {validTimes} = observationData;
  if (!source || validTimes.length === 0) return undefined;
  const values: TimeSeriesData = {};
  const variables: TimeSeriesVariables = {};
  for (const variable of observationData.variables) {
    const column = WEATHER_COLUMN_BY_GROUP[variable.group];
    values[column] = observationData.values[variable.name];
    variables[column] = {unit: variable.unit};
  }
  return {
    query: {siteId, source, columns: Object.keys(values)},
    data: values,
    timestamps: validTimes,
    dataTimeRange: [validTimes[0], validTimes[validTimes.length - 1]],
    variables,
  };
}
